/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_SavedInputs */

const en_model_saved = /** @type {(inputs: Model_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default model saved`)
};

const id_model_saved = /** @type {(inputs: Model_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model default disimpan`)
};

/**
* | output |
* | --- |
* | "Default model saved" |
*
* @param {Model_SavedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_saved = /** @type {((inputs?: Model_SavedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_SavedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_saved(inputs)
	return en_model_saved(inputs)
});